import { render, staticRenderFns } from "./OrderSupportingDocuments.vue?vue&type=template&id=31fd632a&scoped=true&"
import script from "./OrderSupportingDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderSupportingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OrderSupportingDocuments.vue?vue&type=style&index=0&id=31fd632a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd632a",
  null
  
)

export default component.exports